import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import Select from "react-select";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import NewPagination from "components/Common/Newpagination";
import Loader from "pages/Separate/Loader";
import { paymentAlertColumns } from "utils/columns/ElementsColumns/paymentAlertColumns";
import { ResourceType } from "utils/common-options";
import configure from "configure";
import secureLocalStorage from "react-secure-storage";
import { useNavigate } from "react-router-dom";

function TableContainer({ columns, data }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [{ id: "project_name", desc: false }],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  const { pageIndex, pageSize, globalFilter } = state;

  useEffect(() => {
    setPageSize(10);
  }, []);

  return (
    <div>
      <Row>
        <Col xl="12">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-2">
              <div className="mb-3 text-purple fs-5 fw-bold d-flex gap-2">
                Payment Schedule Alert
              </div>

              <div className="flex-grow-1 d-flex justify-content-end mr-2 gap-2">
                {/* Project type dropdown — feeds `type` into FormData */}
                {/* <div className="col-auto" style={{ minWidth: "200px" }}>
<Select
options={ResourceType}
value={ResourceType.find(o => o.value === type) || null}
onChange={opt => setType(opt?.value || "1")}
placeholder="Select Type"
classNamePrefix="select"
/>
</div> */}
                <div className="col-2 cusrtom_search_box">
                  <div className="search-box me-xxl-2 my-xxl-0 d-inline-block w-100 ms-2">
                    <div className="position-relative w-100">
                      <input
                        onChange={(e) => setGlobalFilter(e.target.value)}
                        type="text"
                        className="form-control h-100 w-100"
                        placeholder="Search..."
                        value={globalFilter || ""}
                      />

                      <i className="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="position-relative table-responsive">
              <Table className="table table-bordered mt-4" {...getTableProps()}>
                <thead className="fixed_view_payment_table">
                  {headerGroups.map((headerGroup, i) => (
                    <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, index) => (
                        <th
                          key={index}
                          className={`t-col-${index + 1} ${column.className}`}
                          {...column.getHeaderProps(
                            column.getSortByToggleProps(),
                          )}
                        >
                          {column.render("Header")}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {page.length === 0 ? (
                    <tr>
                      <td
                        colSpan={columns.length}
                        className="text-center text-muted py-4"
                      >
                        No payments due on this date.
                      </td>
                    </tr>
                  ) : (
                    page.map((row, i) => {
                      prepareRow(row);
                      return (
                        <tr key={i} {...row.getRowProps()}>
                          {row.cells.map((cell, index) => (
                            <td key={index} {...cell.getCellProps()}>
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </Table>
            </div>

            <Row className="justify-content-md-end justify-content-center align-items-center">
              <NewPagination
                gotoPage={gotoPage}
                canPreviousPage={canPreviousPage}
                previousPage={previousPage}
                canNextPage={canNextPage}
                pageIndex={pageIndex}
                pageOptions={pageOptions}
                pageSize={pageSize}
                page={page}
                data={data}
                nextPage={nextPage}
              />
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
}

const PRIVILEGED_IDS = ["1", "32", "4", "46"];
const isPrivileged = PRIVILEGED_IDS.includes(localStorage.getItem("auth_id"));

const PaymentScheduleAlert = () => {
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleView = (row) => {
    navigate(`${configure.appUrl}performa_invoice/ztpl#lead`, {
      state: {
        prefill: {
          project_id: row.project_id,
          project_name: row.project_name,
          customer_id: row.customer_id,
          customer_name: row.customer,
          service: row.service,
          rate: row.amount_to_be_paid,
        },
      },
    });
  };

  const GetData = async () => {
    setLoading(true);
    try {
      const formData = new FormData(); // no date needed anymore
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/project_payment_alert`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      const authId = localStorage.getItem("auth_id");
      const raw = response?.data?.data || [];
      setData(
        isPrivileged
          ? raw
          : raw.filter((item) => String(item.assignedBA) === authId),
      );
    } catch (err) {
      console.log(err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, []);

  const handleTick = (row) => {
    Swal.fire({
      title: "Mark this payment as received?",
      text: `${row.project_name} — ${row.milestone}`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, mark done",
      confirmButtonColor: "#28A745",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        const formData = new FormData();
        formData.append("project_id", row.project_id);
        formData.append("milestone_index", row.milestone_index);
        formData.append("user_id", localStorage.getItem("auth_id"));

        await axios({
          method: "post",
          url: `${configure.nodeApi}/project_payment_alert/dismiss`,
          data: formData,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }); // Remove locally immediately without waiting for re-fetch

        setData((prev) =>
          prev.filter(
            (r) =>
              !(
                r.project_id === row.project_id &&
                r.milestone_index === row.milestone_index
              ),
          ),
        );
        Swal.fire({ icon: "success", text: "Marked as received." });
      } catch (err) {
        console.error(err);
        Swal.fire({ icon: "error", text: "Failed to mark as received." });
      }
    });
  };

  const columns = useMemo(
    () => paymentAlertColumns(handleTick, handleView),
    [],
  );

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <Row>
        <Col lg="12">
          <Card>
            <div className="responsive-table">
              <TableContainer columns={columns} data={data} />
            </div>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default PaymentScheduleAlert;
